export enum ReportNavLinks {
  viewInThisGuideWrapper = 'viewInThisGuideWrapper',
  viewIntroductionWrapper = 'viewIntroductionWrapper',
  viewReportWhatIsHeartstyles = 'viewReportWhatIsHeartstyles',
  viewReportUnderstanding = 'viewReportUnderstanding',
  viewReportInterpretGraph = 'viewReportInterpretGraph',
  viewReportProcessingResults = 'viewReportProcessingResults',
  viewReportYourResultsMain = 'viewReportYourResultsMain',
  viewReportYourResults = 'viewReportYourResults',
  viewReportBenchmarkIndic = 'viewReportBenchmarkIndic',
  viewReportSelfScoreIndic = 'viewReportSelfScoreIndic',
  viewReportOthersScoreAverage = 'viewReportOthersScoreAverage',
  viewPersonalResults = 'viewPersonalResults',
  viewReportEffectOver = 'viewReportEffectOver',
  viewReportCampaignEffectiveness = 'viewReportCampaignEffectiveness',
  viewReportCampaignEffectivenessMain = 'viewReportCampaignEffectivenessMain',
  viewReportIndividualFeedback = 'viewReportIndividualFeedback',
  viewReportStopStart = 'viewReportStopStart',
  viewReportWhatNow = 'viewReportWhatNow',
  viewReportStyleSummaries = 'viewReportStyleSummaries',
  viewReportAuthenticPersonalGrowth = 'viewReportAuthenticPersonalGrowth',
  viewReportTransformingPersonalGrowth = 'viewReportTransformingPersonalGrowth',
  viewReportReliablePersonalGrowth = 'viewReportReliablePersonalGrowth',
  viewReportAchievingPersonalGrowth = 'viewReportAchievingPersonalGrowth',
  viewReportRelatingGrowingOthers = 'viewReportRelatingGrowingOthers',
  viewReportEncouragingGrowingOthers = 'viewReportEncouragingGrowingOthers',
  viewReportDevelopingGrowingOthers = 'viewReportDevelopingGrowingOthers',
  viewReportCompassionateGrowingOthers = 'viewReportCompassionateGrowingOthers',
  viewReportSarcasticSelfPromoting = 'viewReportSarcasticSelfPromoting',
  viewReportCompetitiveSelfPromoting = 'viewReportCompetitiveSelfPromoting',
  viewReportControllingSelfPromoting = 'viewReportControllingSelfPromoting',
  viewReportStrivingSelfPromoting = 'viewReportStrivingSelfPromoting',
  viewReportApprovalSeekingSelfProtecting = 'viewReportApprovalSeekingSelfProtecting',
  viewReportEasilyOffendedSelfProtecting = 'viewReportEasilyOffendedSelfProtecting',
  viewReportDependentSelfProtecting = 'viewReportDependentSelfProtecting',
  viewReportAvoidingSelfProtecting = 'viewReportAvoidingSelfProtecting',


  viewReportStyleSummariesQuadrants = 'viewReportStyleSummariesQuadrants',
  viewReportSelfPromotingQuadrants = 'viewReportSelfPromotingQuadrants',
  viewReportGrowingOthersQuadrants = 'viewReportGrowingOthersQuadrants',
  viewReportSelfProtectingQuadrants = 'viewReportSelfProtectingQuadrants',
  viewReportPersonalGrowthQuadrants = 'viewReportPersonalGrowthQuadrants',
}
